export default "__VITE_ASSET__BgFij_sI__"